import { Injectable } from '@angular/core';
import {PageRequest} from '../../shared/models/page-request.interface';
import {Observable, throwError} from 'rxjs';
import {Page} from '../../shared/models/page.interface';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {ErrorMargins} from '../models/error-margins.interface';
import {ApiHttpResponse} from '../../shared/models/api-http-response.interface';
import {catchError, map} from 'rxjs/operators';

const ERROR_API = environment.apiUrl + 'error';

@Injectable({
  providedIn: 'root'
})
export class ErrorMarginsService {

  constructor(private http: HttpClient) { }

  getAll(keyFigure: string, pageRequest: PageRequest = {page: 0, size: 100}): Observable<Page<ErrorMargins>> {
    let url = `${ERROR_API}?size=${pageRequest.size}&page=${pageRequest.page}`;
    let params = '';
    if (keyFigure && keyFigure !== '') {
      params += '&keyFigure=' + keyFigure;
    }
    if (pageRequest.sort && pageRequest.direction) {
      url = url + `&sort=${this.getSortCode(pageRequest.sort)},${pageRequest.direction}`;
    }
    return this.http.get<Page<ErrorMargins>>(url + params);
  }

  editError(dto: ErrorMargins): Observable<ApiHttpResponse<ErrorMargins>> {
    return this.http.put<ApiHttpResponse<ErrorMargins>>(`${ERROR_API}`, dto)
      .pipe(
        catchError(err => {
          return throwError(err);
        }),
        map((res: ApiHttpResponse<ErrorMargins>) => {
          return res;
        })
      );
  }

  private getSortCode(sort: string): string {
    switch (sort) {
      case 'open':
        return 'isReportingAvailable';
      default:
        return sort;
    }
  }
}
